import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GC_I140_Layout } from 'src/app/data/constants/layout-code';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { ProcessingInformationComponent } from '../processing-information/processing-information.component';
import { BeneficiaryPersonalDetailsComponent } from '../beneficiary-personal-details/beneficiary-personal-details.component';
import { EducationDetailsComponent } from '../education-details/education-details.component';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import { JobDescriptionComponent } from '../job-description/job-description.component';
import { select, Store } from '@ngrx/store';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { getStepDetails, getSubTaskDetails, getSubTaskStepList } from '../../store/selectors/sub-task-details.selectors';
import { getSubTaskList } from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { WorkExperienceDetailsComponent } from '../work-experience-details/work-experience-details.component';
import { SubTaskDetails } from 'src/app/data/models/subTaskDetails.model';
import { DependentDetailsComponent } from '../dependent-details/dependent-details.component';
import { PetitionerDetailsComponent } from '../petitioner-details/petitioner-details.component';
import { GetReceiptsComponent } from '../get-receipts/get-receipts.component';
import { SubmitPetitionComponent } from '../submit-petition/submit-petition.component';
import { PrintPetitionComponent } from '../print-petition/print-petition.component';
import { UscisContentComponent } from '../uscis-content/uscis-content.component';
import { ReviewI140PetitionComponent } from '../review-i140-petition/review-i140-petition.component';
import { LetterGenerationComponent } from '../letter-generation/letter-generation.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { UpdateDecisionComponent } from '../update-decision/update-decision.component';
import { BeneficiaryDocumentsComponent } from '../beneficiary-documents/beneficiary-documents.component';
import { SendNotificationComponent } from '../send-notification/send-notification.component';
import { TaskNotesService } from 'task-notes-lib';
import { first, take } from 'rxjs/operators';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { SubTask, TaskSummaryOverview, PrimaryData, SuperTask } from 'app-models';
import * as Task from './../../../superTask/task-state/actions/task.actions';
import { HelpVideoOverlayLibraryComponent } from 'help-video-overlay-library';
import { LockUnlockStepsLibraryService } from 'lock-unlock-steps-library';
import { CustomQuestionnaireService } from 'src/app/modules/custom-questionaire/services/custom-questionnaire.service';
import { MatDialog } from '@angular/material/dialog';
import { CustomStepsComponent } from 'src/app/modules/l1-visa/components/custom-steps/custom-steps.component';
import { OverideUploadFormsLibraryService } from 'overide-upload-forms-library';
import { StepStatusUpdateComponentLibraryService } from 'step-status-update-component-library';
import { DirtyFormGuard, MarkCleanFormAction } from 'dirty-check-store';

@Component({
  selector: 'app-main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.scss'],
  providers: [DialogService]
})
export class MainContainerComponent implements OnInit, AfterViewInit, OnDestroy {

  stepList: TaskStep[];
  toggleSubTaskDetailsPanel: boolean;
  dynamicDialogRef: DynamicDialogRef;
  subTaskDetails: SubTaskDetails;
  i140CaseId: number;
  observableSubscription$ = new Subject();
  @ViewChild(HelpVideoOverlayLibraryComponent, { static: false }) helpVideoComponent: HelpVideoOverlayLibraryComponent;
  userType: string;
  selectedTaskType: string;
  toggleTabText: string = 'TIMELINE';
  primaryData: PrimaryData;
  toggleStatus = 'subTaskDetails';
  customStepList: any;
  superTask: SuperTask;
  taskAllocationUpdateRequired: boolean;
  dialogCloseResult = null;
  dialogRef: any;
  currentStep: TaskStep;
  guardSubscription: any;

  constructor(
    public dialog: MatDialog,
    public dialogService: DialogService,
    private cacheCountyService: CacheCountryService,
    private store: Store<any>,
    private taskNotesService: TaskNotesService,
    public petitionerService: PetitionerService,
    public customQuestionnaireService: CustomQuestionnaireService,
    private lockUnlockStepsLibraryService: LockUnlockStepsLibraryService,
    private overideUploadFormsLibraryService: OverideUploadFormsLibraryService,
        private stepUpdateService: StepStatusUpdateComponentLibraryService,
        private guard: DirtyFormGuard
  ) {
    this.stepList = [];
    this.toggleSubTaskDetailsPanel = false;
    this.userType = sessionStorage.getItem("userTypeRole");
  }

  ngOnInit(): void {
    //set companyId to new variable for Notes feature, current one is overriding based on existing conditions
    sessionStorage.setItem('noteCompanyId', sessionStorage.getItem('companyId'));

    // Get Specific Task Details
    this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTaskDetails) => {
      this.subTaskDetails = data;
      this.selectedTaskType = this.subTaskDetails['subTaskTypeCode'];
    });
    // Get sub task list
    this.store.pipe(select(getSubTaskList)).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTask[]) => {
      this.i140CaseId = (data.find(x => x.taskTypeCode === 'I140')).caseId;
      this.store.dispatch(loadSubTaskDetails({ taskId: parseInt(data.find(x => x.taskTypeCode === 'I140').id.toString()) }));
    });
    this.overideUploadFormsLibraryService.fetchi140StepDetails
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((id: number) => {
        this.store.pipe(select(getStepDetails, { id })).pipe(take(1)).subscribe((data: TaskStep) => {
          this.overideUploadFormsLibraryService.receivei140StepDetails.next(data);
        });
      });
    // Get Step list
    this.store.pipe(select(getSubTaskStepList)).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep[]) => {
      if (this.subTaskDetails?.superTaskId) {
        this.petitionerService.getSuperTask(this.subTaskDetails.superTaskId)
          .pipe(take(1))
          .subscribe((data: any) => {
            this.superTask = data.superTask;
          });
      }
      if (this.subTaskDetails.taskTypeId) {
        sessionStorage.setItem('taskTypeId', JSON.parse(JSON.stringify(this.subTaskDetails.taskTypeId)));
        let companyId: any = this.subTaskDetails.createdByUserType === "Attorney" ? this.subTaskDetails.attorneyId : this.subTaskDetails.companyId;
        sessionStorage.setItem('companyId', companyId)
        let userType = localStorage.getItem('userTypeRole');
        if (userType === 'Beneficiary') {
          localStorage.setItem('cqCompanyId', companyId);
        }
        this.customQuestionnaireService.getCustomStepsDetails(companyId, this.subTaskDetails.taskTypeId).pipe(take(1)).subscribe((cqData: any) => {
          this.customQuestionnaireService.masterData = cqData;
          if (this.subTaskDetails.taskCustomStepDetails.length !== cqData.customStepList.length) {
            this.taskAllocationUpdateRequired = true;
          }
          if (cqData.customStepList.length) {
            let allocatedCustomSteps = this.subTaskDetails.taskCustomStepDetails.filter(c => c.isBeneficiaryAction).map(o => o.stepName);
            let customSteps = [];
            cqData.customStepList.forEach(element => {
              if (allocatedCustomSteps.indexOf(element.stepName) > -1) {
                if (element.isBeneficiaryEditable || element.isBeneficiaryVisible) customSteps.push(element)
              }
            });
            this.customStepList = customSteps.reverse();
            for (var i = 0; i < this.customStepList.length; i++) {
              let allindex = data.filter(x => x.stepName === this.customStepList[i].previousStepName);
              let index = data.findIndex(x => x.stepName === this.customStepList[i].previousStepName);
              this.customStepList[i]['isCustomStep'] = true;
              // data.splice(index + 2, 0, this.customStepList[i]);
              this.customStepList[i].stepPosition === 'before' ? '' : index = allindex.length > 1 ? index + 2 : index + 1;
              data.splice(index, 0, this.customStepList[i]);
            }
          }
          this.stepList = data;
          if(this.currentStep){
            let index = this.stepList.findIndex(x => x.id === this.currentStep?.id);
            this.stepUpdateService.nextPrevVisisbilitySubject.next({showPrev:(index == 0)? false : true, showNext: this.getNextStepVisibility(index)});
          }
        });
      }
    });
    this.cacheCountyService.getCountry().subscribe(); // This is to load countries in a cache service

    this.taskNotesService.onNotesUpdated
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(() => {
        this.petitionerService.getSuperTask(this.subTaskDetails.superTaskId)
          .pipe(take(1))
          .subscribe((taskSummaryOverview: TaskSummaryOverview) => {
            this.store.dispatch(new Task.SetTaskSummaryOverview(taskSummaryOverview));
          });
      });


    this.lockUnlockStepsLibraryService.onlockedUpdated
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(() => {
        this.petitionerService.getSuperTask(this.subTaskDetails.superTaskId)
          .pipe(take(1))
          .subscribe((taskSummaryOverview: TaskSummaryOverview) => {
            this.store.dispatch(new Task.SetTaskSummaryOverview(taskSummaryOverview));
          });
      });
    this.stepUpdateService.closeSubject$.subscribe(result => {
      this.dialogCloseResult = result;
      if(this.dynamicDialogRef){
        //this.dynamicDialogRef.close();
        this.checkDirty();
      }
      if(this.dialogRef?.componentInstance && this.dialogRef?.componentInstance?.data?.stepId === result?.currentStep?.stepId){
        this.dialogRef?.close();
      }
    });
  }

  ngAfterViewInit() {
    if (this.selectedTaskType === 'RFE') {
      if (this.userType !== 'Beneficiary') {
        this.helpVideoComponent.setTabValues('right', 'Building an RFE Response', 'Part 1: Building an RFE Response', 'Part 1: Building an RFE Response',
          'right', 'Part 2: Building an RFE Response', 'Part 2: Building an RFE Response'
        );
      }
    } else {
      if (this.userType !== 'Beneficiary') {
        this.helpVideoComponent.setValues('right', 'Next steps after Tasks creation', 'Next steps after Tasks creation');
      } else {
        this.helpVideoComponent.setValues('right', 'Using Timelines and Notifications for Beneficiary', 'Using Timelines and Notifications for Beneficiary');
      }
    }
  }

  handleSubTaskPanelToggle(value: boolean) {
    this.toggleSubTaskDetailsPanel = value;
  }

  handleStepClick(step: TaskStep) {
    //Send Notification does't work while Document Checklist tab is active so activating timeline Tab.
    this.currentStep = step;
    let index = this.stepList.findIndex(x => x.id===step.id);
    let showPrev = (index == 0)? false : true;
    //let showNext = (index>= 0 && index< this.stepList.length - 1)? true : false;
    if (step.previousStepName != null) {
      const dialogRef = this.dialog.open(CustomStepsComponent, {
        disableClose: true,
        width: '900px',
        height: '70vh',
        panelClass: 'custom-questionnaire-dialog-container',
        data: { stepName: step.stepName, taskId: step.taskId ? step.taskId : this.subTaskDetails.id, subTaskDetails: this.subTaskDetails, stepId: step.id, beneficiaryId: this.superTask.beneficiaryId, isCustomStep: true, showPrev: showPrev, showNext: this.getNextStepVisibility(index) }
      },
      );
      dialogRef.afterClosed().subscribe(result => {
        if (this.dialogCloseResult) {
          let currentStepIndex = this.stepList.findIndex(item => item.id == this.dialogCloseResult['currentStep'].id);
          if (this.dialogCloseResult['action'] === 'prev') {
            if (currentStepIndex > 0) {
              let stepToNavigate = this.getStepFromListing(currentStepIndex,'prev');
              this.handleStepClick(stepToNavigate);
              this.dialogCloseResult = null;
            }
          } else if (this.dialogCloseResult['action'] === 'next') {
            if (currentStepIndex > -1 && currentStepIndex < this.stepList.length) {
              let stepToNavigate = this.getStepFromListing(currentStepIndex,'next');
              this.handleStepClick(stepToNavigate);
              this.dialogCloseResult = null;
            }
          }
        }else{
          this.ngOnInit();
        }
      });
    } else {
      this.toggleTabText = 'TIMELINE';
      this.dynamicDialogRef = this.dialogService.open(this.getStepComponent(step.stepName), {
        width: '100%',
        contentStyle: { 'max-height': '100vh', 'z-index': '1000', 'padding-bottom': '15px', 'overflow-y': 'hidden' },
        closable: false,
        showHeader: false,
        closeOnEscape: false,
        modal: true,
        dismissableMask: true,
        data: {
          superTaskId: this.subTaskDetails.superTaskId,
          subTaskId: this.subTaskDetails.id,
          taskTypeId: this.subTaskDetails.taskTypeId,
          i140CaseId: this.i140CaseId,
          stepId: step.id,
          stepName: step.stepName,
          companyId: step.companyId,
          petitionerId: step.petitionerId,
          //adding these info to make the credit card info component to work for G-forms
          caseId: this.i140CaseId,
          visatype: 'GC',
          caseType: 'I140',
          showPrev: showPrev,
          showNext: this.getNextStepVisibility(index)
        },
      });
      this.dynamicDialogRef.onClose.subscribe(() => {
        if (this.dialogCloseResult) {
          let currentStepIndex = this.stepList.findIndex(item => item.id == this.dialogCloseResult['currentStep'].id);
          if (this.dialogCloseResult['action'] === 'prev') {
            if (currentStepIndex > 0) {
              let stepToNavigate = this.getStepFromListing(currentStepIndex,'prev');
              this.handleStepClick(stepToNavigate);
              this.dialogCloseResult = null;
            }
          } else if (this.dialogCloseResult['action'] === 'next') {
            if (currentStepIndex > -1 && currentStepIndex < this.stepList.length) {
              let stepToNavigate = this.getStepFromListing(currentStepIndex,'next');
              this.handleStepClick(stepToNavigate);
              this.dialogCloseResult = null;
            }
          }
        }else{
          this.ngOnInit();
        }
      })
    }
  }

  checkDirty(){
      this.guardSubscription = this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
        if (response) {
          this.store.dispatch(new MarkCleanFormAction({
            dirty: false
          }));
          this.closeDialog();
        }
        else {
          return false;
        }
      });
    }
  
    closeDialog(){
      this.dynamicDialogRef.close();
    }

  getNextStepVisibility(index){
    let showNext = false;
    if(this.userType === 'Attorney'){
      showNext = (index>= 0 && index< this.stepList.length - 1 && this.stepList[index +1 ].isAttorneyEditable==1)? true : false; 
    }else if(this.userType === 'Petitioner'){
      showNext = (index>= 0 && index< this.stepList.length - 1 && this.stepList[index +1 ].isPetitionerEditable==1)? true : false; 
    }else if(this.userType === 'Beneficiary'){
      showNext = (index>= 0 && index< this.stepList.length - 1 && this.stepList[index +1 ].isBeneficiaryEditable==1)? true : false; 
    }
    return showNext;
  }

  getStepComponent(stepName) {
    switch (stepName) {
      case GC_I140_Layout.PROCESSING_INFORMATION:
        return ProcessingInformationComponent;
      case GC_I140_Layout.JOB_DESCRIPTION:
        return JobDescriptionComponent;
      case GC_I140_Layout.BENIFICARY_PROFILE_DETAILS:
        return BeneficiaryPersonalDetailsComponent;
      case GC_I140_Layout.EDU_DETAIL:
        return EducationDetailsComponent;
      case GC_I140_Layout.BEN_EDU_DETAIL:
        return EducationDetailsComponent;
      case GC_I140_Layout.BENIFICARY_EXPERIENCE_DETAILS:
        return WorkExperienceDetailsComponent;
      case GC_I140_Layout.BEN_EXP_DETAIL:
        return WorkExperienceDetailsComponent;
      case GC_I140_Layout.DEPENDENT_INFO:
        return DependentDetailsComponent;
      case GC_I140_Layout.BEN_DEPENDENT_INFO:
        return DependentDetailsComponent;
      case GC_I140_Layout.PROVIDE_BEN_DOCS:
        return BeneficiaryDocumentsComponent;
      case GC_I140_Layout.BEN_PROVIDE_BEN_DOCS:
        return BeneficiaryDocumentsComponent;
      case GC_I140_Layout.PET_DOC_AND_DETAILS:
        return PetitionerDetailsComponent;
      case GC_I140_Layout.USCIS_CONTENT:
        return UscisContentComponent;
      case GC_I140_Layout.REVIEW_I140_PET:
        return ReviewI140PetitionComponent;
      case GC_I140_Layout.PRINT_I140_PET:
        return PrintPetitionComponent;
      case GC_I140_Layout.SUB_I140_PET:
        return SubmitPetitionComponent;
      case GC_I140_Layout.GET_RECEIPT:
        return GetReceiptsComponent;
      case GC_I140_Layout.LETTER_GEN:
        return LetterGenerationComponent;
      case GC_I140_Layout.UPDATE_DECISION:
        return UpdateDecisionComponent;
      case GC_I140_Layout.SEND_NOTIFICATION:
        return SendNotificationComponent;
    }
  }

  getStepFromListing(currentStepIndex: number, flag: string){
    switch(flag){
      case 'prev':
          currentStepIndex--;
          break;
      case 'next':
          currentStepIndex++;
          break;
    }
    if(this.userType === 'Beneficiary'){
      return this.stepList[currentStepIndex]?.isBeneficiaryAction === 1 && this.stepList[currentStepIndex]?.isBeneficiaryVisible ? this.stepList[currentStepIndex] : this.getStepFromListing(currentStepIndex,flag);
    }if(this.userType === 'Petitioner'){
      return this.stepList[currentStepIndex]?.isBeneficiaryAction === 0 && this.stepList[currentStepIndex]?.isPetitionerAction === 1 && (this.stepList[currentStepIndex]?.isVisible || this.stepList[currentStepIndex]?.isPetitionerVisible) ? this.stepList[currentStepIndex] : this.getStepFromListing(currentStepIndex,flag);
    }else{ //Attorney Login
      return this.stepList[currentStepIndex]?.isBeneficiaryAction === 0 && this.stepList[currentStepIndex]?.isAttorneyAction === 1 && (this.stepList[currentStepIndex]?.isVisible || this.stepList[currentStepIndex]?.isAttorneyVisible) ? this.stepList[currentStepIndex] : this.getStepFromListing(currentStepIndex,flag);
    }
  }

  preparePrimaryData() {
    this.primaryData = {
      beneficiaryId: this.subTaskDetails.beneficiaryId,
      companyId: this.subTaskDetails['companyId'] ? this.subTaskDetails['companyId'] : null,
      superTaskId: this.subTaskDetails.superTaskId,
      subTaskId: this.subTaskDetails.id,
      caseType: this.selectedTaskType,
      petitionId: this.subTaskDetails.id,
      caseId: this.i140CaseId,
      foreignCompanyId: this.subTaskDetails['foreignCompanyId'],
      visatype: this.subTaskDetails.taskTypeDetails['immCategoryCode'],
      visaName: 'I-140',
      jsonInput: { subTaskDetails: this.subTaskDetails },
      petitionType: this.subTaskDetails.taskTypeDetails['immClassificationCode'],
      immSpecialistId: this.subTaskDetails.immSpecialistId,
      attorneyId: this.subTaskDetails.attorneyId,
      immigrationCategory: this.subTaskDetails.taskTypeDetails['immCategoryCode'],
      immigrationCategoryName: this.subTaskDetails.taskTypeDetails['immCategory'],
      immigrationClassification: this.subTaskDetails.taskTypeDetails['immClassificationCode'],
      immigrationClassificationName: this.subTaskDetails.taskTypeDetails['immClassification']
    };
  }

  toggleMode(mode) {
    this.toggleStatus = mode;
  }

  ngOnDestroy() {
    sessionStorage.removeItem("noteCompanyId");
    if (this.dynamicDialogRef) {
      this.dynamicDialogRef.close();
    }
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
